import { Region, Currency } from '../../lib/auth/region';

export type BankDetails = BankDetailsSEPA | BankDetailsUK | BankDetailsUS;

export type BankDetailsSEPA = {
    currency: Currency.EUR;
    firstName: string;
    lastName: string;
    iban: string;
    bic: string;
};

export type BankDetailsUK = {
    currency: Currency.GBP;
    fullName: string;
    accountNumber: string;
    sortCode: string;
};

export type BankDetailsUS = {
    currency: Currency.USD;
    fullName: string;
    routingNumber: string;
    accountNumber: string;
    accountType: AccountTypeUS;
    address: AddressDetailsUS;
};

export enum AccountTypeUS {
    checking = 'CHECKING',
    savings = 'SAVINGS',
}

type AddressDetailsUS = {
    firstLine: string;
    city: string;
    postCode: string;
    state: string;
    country: string;
};

/**
 * Strips ALL whitespace (not just the first space) and uppercases an IBAN or BIC before it is
 * validated, saved, and sent to the backend. IBANs are commonly typed or pasted with grouping
 * spaces ("FR76 3000 4000…"); the IBAN validator tolerates them, but the raw string is forwarded
 * verbatim to the bank transfer providers and Revolut rejects IBANs longer than 34 characters.
 */
export function formatBicAndIban(input: string): string {
    return input.replace(/\s/g, '').toUpperCase();
}

export function buildEmptyBankDetails(userRegion: Region): BankDetails {
    switch (userRegion) {
        case Region.GB:
            return buildEmptyBankDetailsUK();
        case Region.US:
            return buildEmptyBankDetailsUS();
        case Region.FR:
            return buildEmptyBankDetailsSEPA();
    }
}

function buildEmptyBankDetailsUK(): BankDetailsUK {
    return { currency: Currency.GBP, fullName: '', accountNumber: '', sortCode: '' };
}

function buildEmptyBankDetailsUS(): BankDetailsUS {
    return {
        currency: Currency.USD,
        fullName: '',
        routingNumber: '',
        accountNumber: '',
        accountType: AccountTypeUS.checking,
        address: {
            firstLine: '',
            city: '',
            postCode: '',
            state: '',
            country: 'US',
        },
    };
}

function buildEmptyBankDetailsSEPA(): BankDetailsSEPA {
    return { currency: Currency.EUR, firstName: '', lastName: '', iban: '', bic: '' };
}
